import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
const ComingSoon = () => {
  return (
    <Box
      sx={{
        width: { xs: "85%", lg: 400 },
        height: "100%",
        bgcolor: "background.paper",
        borderRadius: 4,
        mx: "auto",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <AccessTimeIcon
          sx={{
            fontSize: { xs: 16, lg: 32 },
            color: "#003D78",
            mb: 1,
          }}
        />
        <Typography
          variant="h5"
          component="h2"
          gutterBottom
          sx={{
            fontWeight: "bold",
            color: "#003D78",
            fontSize: { xs: "20px", lg: "24px" },
          }}
        >
          Coming Soon
        </Typography>
        <Divider sx={{ width: "100%", my: 1 }} />
        <Typography
          variant="body1"
          textAlign="center"
          sx={{ mb: 3, fontSize: { xs: "14px", lg: "16px" } }}
        >
          This feature is currently under development. <br />
          Stay tuned for updates!
        </Typography>
      </Box>
    </Box>
  );
};

export default ComingSoon;
